
import { Badge } from "@/components/ui/badge";

interface SelectedApp {
  appName: string;
  developerName?: string;
  iconUrl?: string;
  category?: string;
  version?: string;
  description?: string;
}

interface SelectedAppPreviewProps {
  selectedApp: SelectedApp;
}

export const SelectedAppPreview = ({ selectedApp }: SelectedAppPreviewProps) => {
  return (
    <div className="border rounded-md p-3 bg-blue-50">
      <div className="flex items-center">
        <div className="w-8 h-8 bg-gray-100 rounded mr-3 flex-shrink-0">
          {selectedApp.iconUrl ? (
            <img 
              src={selectedApp.iconUrl} 
              alt={selectedApp.appName}
              className="w-8 h-8 rounded"
            />
          ) : (
            <div className="w-8 h-8 bg-blue-100 rounded flex items-center justify-center">
              <span className="text-xs text-blue-600">{selectedApp.appName[0]}</span>
            </div>
          )}
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-900">{selectedApp.appName}</p>
          <p className="text-xs text-gray-500">{selectedApp.developerName}</p>
          <div className="flex items-center gap-2 mt-1">
            {selectedApp.category && (
              <Badge variant="outline" className="text-xs">
                {selectedApp.category}
              </Badge>
            )}
            {selectedApp.version && (
              <Badge variant="outline" className="text-xs">
                v{selectedApp.version}
              </Badge>
            )}
          </div>
          {selectedApp.description && (
            <p className="text-xs text-gray-600 mt-2 line-clamp-2">{selectedApp.description}</p>
          )}
        </div>
      </div>
    </div>
  );
};
